import { bolognaCentrale } from "./bologna-centrale";
import { romaTiburtina } from "./roma-tiburtina";
import { torinoPortaSusa } from "./torino-porta-susa";

export const easyLevels = [bolognaCentrale, romaTiburtina, torinoPortaSusa];
